import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import SyncData from 'modules/payroll_integrations_datev_api/components/Incidence/SyncData'
import type { DiffFields } from 'modules/payroll_integrations_datev_api/lib/IncidenceSync/store'
import fieldTranslations from 'modules/payroll_integrations_datev_api/lib/fieldTranslations'

const Available = ({
  diffFields,
  onSync,
  syncing,
}: {
  diffFields: DiffFields | null
  onSync: () => void
  syncing: boolean
}) => {
  const diffFieldNames = Object.keys(diffFields || {})
  const translatedDiffFieldNames = diffFieldNames
    .map((fieldName) => fieldTranslations.t(fieldName))
    .join(', ')

  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.datev_api.contract_data.available.title')}
      </Text.Header2>
      <Box>
        {i18n.tp('payroll_integrations.incidences.datev_api.contract_data.available.message', {
          fieldNames: translatedDiffFieldNames,
          count: diffFieldNames.length,
        })}
      </Box>
      {diffFields && <SyncData fields={diffFields} onSync={onSync} syncing={syncing} />}
    </>
  )
}

export default Available
